import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Notifications from 'vue-notification';
import * as api from '@/api/api.js';
import { roleMap } from '@/config';
import { dynamicRoutes } from '@/router/config';
import {
  Cascader,
  Icon,
  Dialog,
  Loading,
  Table,
  TableColumn,
  Backtop,
  Checkbox,
  Button,
  Message,
  Image,
  Switch,
  Form,
  FormItem,
  Input,
  Row,
  Col,
  Tooltip,
  Select,
  Option,
  DatePicker,
  Tree,
  Collapse,
  CollapseItem,
  Autocomplete,
  Tabs,
  TabPane,
  Tag,
  MessageBox,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vcharts from 'v-charts';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import VueSocketIO from 'vue-socket.io';

Vue.config.productionTip = false;
Vue.use(Notifications);
Vue.use(Cascader);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Backtop);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Image);
Vue.use(Switch);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tooltip);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Tree);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Autocomplete);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(vcharts);
Vue.prototype.$nprogress = NProgress;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.use(
  new VueSocketIO({
    debug: false,
    // 服务器端地址
    connection: '',
    // connection: 'http://192.168.7.25:8257',
    // connection: 'http://localhost:8258',
    vuex: {},
    options: { path: '/api/socket.io' },
    // options: { path: '/socket.io' },
  }),
);

router.beforeEach((to, from, next) => {
  const token = window.localStorage.hsJwt;
  if (!store.state.role && !(to.name === 'login' || to.name === 'personlogin')) {
    if (token) {
      api
        .getUserInfo()
        .then(res => {
          window.localStorage.setItem('hsJwt', res.data.token);
          store.commit({ type: 'setRole', role: roleMap[res.data.user.roleId] });
          store.commit({ type: 'setUserName', userName: res.data.user.userName });
          store.commit({ type: 'setUserId', userId: res.data.user.id });
          router.addRoutes(dynamicRoutes[roleMap[res.data.user.roleId] + 'Routes']);
          next(to);
        })
        .catch(() => {
          window.localStorage.removeItem('hsJwt');
          next('/login');
        });
    } else next('/login');
  } else next();

  // if (to.name === 'login' || to.name === 'personlogin' || store.state.role) {
  //   next();
  // } else {
  //   next('/login');
  // }
});

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

export { app, router, store };
